import { fetchFriendChallenges, fetchHouseholdChallenges } from './challengeWireApi';

export const CURRENT_CHALLENGE_STATUSES = new Set(['pending_acceptance', 'active']);

export function isCurrentChallenge(challenge) {
	return CURRENT_CHALLENGE_STATUSES.has(challenge?.status);
}

export function filterCurrentChallenges(challenges) {
	return (challenges || []).filter(isCurrentChallenge);
}

export async function fetchProfileChallenges({
	userId,
	fitnessProfileId,
	isPrimary,
	friendEndpoint,
	householdEndpoint,
	csrfToken
}) {
	const householdPromise = fetchHouseholdChallenges({
		userId,
		endpoint: householdEndpoint,
		csrfToken,
		status: 'active',
		fitnessProfileId
	});

	const friendPromise = isPrimary
		? fetchFriendChallenges({ userId, endpoint: friendEndpoint, csrfToken, role: 'current' })
		: Promise.resolve([]);

	const [household, friends] = await Promise.all([householdPromise, friendPromise]);

	return filterCurrentChallenges([...friends, ...household]);
}
